import React from 'react';
import { useTranslation } from '../../i18n/I18nProvider';

const LANGUAGES = [
  { code: 'fr', labelKey: 'lang.fr' },
  { code: 'en', labelKey: 'lang.en' },
];

export default function LanguageSwitcher({ className = '' }) {
  const { language, setLanguage, t } = useTranslation();

  return (
    <div className={`language-switcher ${className}`.trim()}>
      <select
        className="language-switcher__select"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        aria-label="Language"
      >
        {LANGUAGES.map(({ code, labelKey }) => (
          <option key={code} value={code}>
            {t(labelKey)}
          </option>
        ))}
      </select>
    </div>
  );
}
